import { SxProps } from '@mui/material';
import { Theme } from '@mui/material/styles';
import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { NavigationDataItem } from 'src/components/Navbar/use-navigation-items';
import { useNavigateRoute } from 'src/utils/routing';
import { NavigationItem } from './navigation-item';
import { isPathActive } from './utils';

export const StaticNavItem = ({
  item,
  onClick,
  sx,
}: {
  item: NavigationDataItem;
  onClick?: (item: NavigationDataItem) => void;
  sx?: SxProps<Theme>;
}) => {
  const { navigate, pathnameWithoutPrefix } = useNavigateRoute();
  const location = useLocation();

  const isActive = useMemo(
    () =>
      isPathActive({
        pathTemplate: item.pathTemplate,
        path: item.path,
        locationPath: pathnameWithoutPrefix,
      }),
    [item.path, item.pathTemplate, pathnameWithoutPrefix],
  );

  const handleClick = () => {
    if (onClick) {
      onClick(item);
      return;
    }

    if (item.path && item.path !== location.pathname) {
      navigate(item.path);
    }
  };

  return <NavigationItem item={item} onClick={handleClick} isActive={isActive} sx={sx} />;
};
